export default "__VITE_ASSET__DTzVosw3__"